import { ApplicationConfig, provideZoneChangeDetection, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { requestAuthInterceptor, responseInterceptor, SPECTRUM_API_PATH, SPECTRUM_AUTH_API, provideSpectrumGuide } from 'common';
import { environment } from '../environments/environment';
import { LUCIDE_ICONS, LucideIconProvider } from 'lucide-angular';
import {
    LayoutDashboard, IndianRupee, Users, Wallet, Landmark, ReceiptText,
    ShoppingCart, BarChart3, Settings, ChevronDown, ChevronRight, ChevronLeft,
    Plus, Check, X, Menu, Bell, Calendar, CalendarDays, ClipboardList, Eye,
    Trash2, Save, Send, Download, Upload, Search, Filter, Printer,
    AlertCircle, AlertTriangle, CheckCircle, XCircle, Info, Copy, LogOut,
    PanelLeftClose, PanelLeftOpen, FileText, FileSpreadsheet, CreditCard,
    Banknote, QrCode, Link, MessageCircle, Phone, Clock, History,
    TrendingUp, TrendingDown, PiggyBank, HandCoins, BadgePercent, Ban,
    RefreshCw, ArrowLeft, ArrowRight, MoreVertical, Pencil, UserRound, Building2,
    Table2, Tags, Puzzle, Gavel, BellRing, Siren, FolderTree
} from 'lucide-angular';

export const appConfig: ApplicationConfig = {
    providers: [
        provideSpectrumGuide({
            module: 'finance',
            title: 'Finance',
            manual: () => import('./help/finance.manual').then(m => m.FINANCE_MANUAL)
        }),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideBrowserGlobalErrorListeners(),
        provideRouter(routes),
        provideHttpClient(withInterceptors([requestAuthInterceptor, responseInterceptor])),
        provideAnimations(),
        { provide: SPECTRUM_API_PATH, useValue: environment.externalApiPath },
        { provide: SPECTRUM_AUTH_API, useValue: environment.authBaseUrl },
        {
            provide: LUCIDE_ICONS,
            multi: true,
            useValue: new LucideIconProvider({
                LayoutDashboard, IndianRupee, Users, Wallet, Landmark, ReceiptText,
                ShoppingCart, BarChart3, Settings, ChevronDown, ChevronRight, ChevronLeft,
                Plus, Check, X, Menu, Bell, Calendar, CalendarDays, ClipboardList, Eye,
                Trash2, Save, Send, Download, Upload, Search, Filter, Printer,
                AlertCircle, AlertTriangle, CheckCircle, XCircle, Info, Copy, LogOut,
                PanelLeftClose, PanelLeftOpen, FileText, FileSpreadsheet, CreditCard,
                Banknote, QrCode, Link, MessageCircle, Phone, Clock, History,
                TrendingUp, TrendingDown, PiggyBank, HandCoins, BadgePercent, Ban,
                RefreshCw, ArrowLeft, ArrowRight, MoreVertical, Pencil, UserRound, Building2,
                Table2, Tags, Puzzle, Gavel, BellRing, Siren, FolderTree
            })
        }
    ]
};
